import React from 'react';
import { observer, inject } from 'mobx-react';
import {
    Theme,
    Modal,
    Paper,
    Typography,
    Button,
    ModalProps,
    ButtonProps,
} from '@mui/material';
import { createStyles, WithStyles, withStyles } from '@mui/styles';
import { Trans, WithTranslation, withTranslation } from 'react-i18next';

import { WizardModel, Billpay } from 'models/kiosk';
import { Services } from 'helpers';
import { defaultStyle } from './CommonModalStyles';

type ModalWithoutChildrenProps = Omit<ModalProps, 'children'>;

interface NoChangeMessageModalProps
    extends WithStyles<typeof styles>,
        WithTranslation {
    modalProps?: ModalWithoutChildrenProps;
    buttonProps?: ButtonProps;
}
interface NoChangeMessageModalPropsInjected extends NoChangeMessageModalProps {
    wizard: WizardModel;
    billpay: Billpay;
}

const styles = (theme: Theme) =>
    createStyles(defaultStyle);

@inject(Services.BILLPAY)
@observer
class NoChangeMessageModal extends React.Component<
    NoChangeMessageModalProps,
    any
> {
    get injected() {
        return this.props as NoChangeMessageModalPropsInjected;
    }

    render() {
        const { modalProps, buttonProps, classes, t } = this.props;
        const { billpay } = this.injected;

        return (
            <Modal
                aria-labelledby='close-warning-title'
                aria-describedby='close-warning-description'
                open={false}
                {...modalProps}
            >
                <Paper className={classes.root}>
                    {/* <div className={classes.header}>
                        <Typography variant="h3">{t("Error")}</Typography>
                    </div> */}
                    <div className={classes.body}>
                        <Typography
                            variant='h4'
                            style={{ fontWeight: 'normal' }}
                            align='center'
                        >
                            <Trans
                                i18nKey='NoChangeMsg'
                                values={{
                                    accountNumber: `*****${billpay.accountNumberLast4}`,
                                }}
                            >
                                This kiosk{' '}
                                <strong>cannot dispense change</strong>. All
                                extra money deposited will be applied as a{' '}
                                <strong>credit</strong> to the account ending in
                                *****{billpay.accountNumberLast4}.
                            </Trans>
                        </Typography>
                    </div>

                    <div className={classes.footer}>
                        <Button
                            variant='primary'
                            style={{ width: 200 }}
                            {...buttonProps}
                        >
                            <Typography variant='button'>{t('OK')}</Typography>
                        </Button>
                    </div>
                </Paper>
            </Modal>
        );
    }
}

export default withTranslation()(withStyles(styles)(NoChangeMessageModal));
